export default "/images/solucoes_que_impactam.png?f8e458a43eaf278bec31d03b52b4524d";